import {
  ActionNames,
  HostEditActionsDictionary,
} from '@wix/editor-platform-host-integration-apis';
import { EditAction, ContributedEditActionsDict } from './types';
import { platformNativeActions } from './nativeActions';
import { systemActions } from './systemActions';

// init store & set default platform actions
const store = new Map<ActionNames, EditAction>(
  Object.entries({
    ...platformNativeActions,
    ...systemActions,
  }) as [ActionNames, EditAction][],
);

const setAction = (actionName: ActionNames, action: EditAction) => {
  return store.set(actionName, action);
};

const setActions = (actions: ContributedEditActionsDict) => {
  const actionNames = Object.keys(actions) as ActionNames[];
  actionNames.forEach((actionName) => {
    setAction(actionName, actions[actionName]!);
  });
};

const getActionByActionName = (actionName: ActionNames) => {
  return store.get(actionName) ?? null;
};

const contributeActions = (actions: Partial<HostEditActionsDictionary>) => {
  setActions(actions);
};

const getActions = () => {
  return Array.from(store.values());
};

const getActionsByActionNames = (actionNames: ActionNames[]) => {
  return actionNames
    .map((actionName) => getActionByActionName(actionName)!)
    .filter((action) => !!action);
};

const getStoreSlice = <TAction extends EditAction = EditAction>(
  actionNames: ActionNames[],
) => {
  return Object.fromEntries(
    actionNames
      .map((actionName) => {
        const action = getActionByActionName(actionName) as TAction | null;
        return [actionName, action];
      })
      .filter(([, action]) => action !== null),
  ) as Partial<Record<ActionNames, TAction>>;
};

export const EditActionsStore = {
  setAction,
  setActions,
  getActions,
  getActionByActionName,
  getActionsByActionNames,
  getStoreSlice,
  contributeActions,
};
